import React, { useState, useMemo } from 'react';
import { Tab, Tabs, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import strings from '../../Globalization/index';
import { useModelForm } from '../../contexts/ModelForm';
import FormGroupInputs from './FormGroupInputs';

const TabFormGroups = () => {
	const { formGroups } = useModelForm()
	const theme = useTheme();
	const tabs = useMemo(
		() =>
			Array.isArray(formGroups)
				? formGroups.map(({ header, id, headerProps }, index) => ({
						id: id || index,
						label: header || 'Tab',
						headerProps: headerProps
				  }))
				: [],
		[]
	);
	const [tab, setTab] = useState(0);

	const formGroup = formGroups.find(({ id }, index) => tab === id || tab === index);

	const handleOnChangeTab = (event, newValue) => {
		setTab(newValue);
	};

	return (
		<Grid
			container
			sx={{
				'& .MuiTabScrollButton-root.Mui-disabled': {
					opacity: 0.3
				}
			}}
		>
			<Grid size={12}>
				<Tabs
					value={tab}
					onChange={handleOnChangeTab}
					variant="scrollable"
					scrollButtons="auto"
					allowScrollButtonsMobile
					aria-label="scrollable force form group tabs"
				>
					{tabs.map(({ id, label, headerProps }, i) => (
						<Tab label={strings[label] || label} value={id} {...headerProps} key={`form-group-tab-${i}`} />
					))}
				</Tabs>
			</Grid>

			{Array.isArray(formGroup?.inputs) && (
				<Grid
					container
					size={12}
					sx={{
						paddingTop: theme.spacing(1),
						'& .formGroupInputWrapper': { display: 'flex', alignItems: 'center' }
					}}
					spacing={3}
					{...formGroup.containerProps}
				>
					<FormGroupInputs
						formGroup={formGroup}
					/>
				</Grid>
			)}
		</Grid>
	);
};

export default TabFormGroups;
